import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { globalData } from '../global/global_data';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  public customerIdSession

  constructor(private http: HttpClient) { }

  getCustomers(): Observable<any> {
    return this.http.get(`${globalData.urls.rootURI}${globalData.urls.cust}`);
  }

  getPolitics(): Observable<any> {
    return this.http.get(`${globalData.urls.rootURI}${globalData.urls.custPolitics}`);
  }
  getByDomain(domain): Observable<any> {
    return this.http.get(`${globalData.urls.rootURI}${globalData.urls.custByDomain}/${domain}`);  
  }

  getById(id): Observable<any> {
    //console.log('id::::::::::',id)
    return this.http.get(`${globalData.urls.rootURI}${globalData.urls.custById}/${id}`); 
  }

  idSession(data){
    this.customerIdSession = data
  }
  

}
